<template>
  <div
    class="container"
    id="ContactUs"
    style="backgroundImage: url(./img/background2x2.png); background-size: cover; min-height: calc(100vh - 66px);"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <br /><br />
      </div>
      <div class="md-layout-item md-size-10 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <br /><br />
        <h2 class="title">
          <font><br /><br />{{ $t("Send us a message") }}</font>
        </h2>
        <h3 class="description">
          {{ $t("Got a question? We'd love to hear from you.") }}<br />{{
            $t("Contact us with anything related to our Products.")
          }}<br />{{ $t("We'll get in touch with you as soon as possible.") }}
        </h3>
      </div>
      <div id="contactuss" class="md-layout-item md-size-40 md-small-size-100">
        <br /><br />
        <md-card class="md-card-contact">
          <md-card-header class="text-center">
            <h2 class="card-title">{{ $t("Contact Us") }}</h2>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label>{{ $t("First Name") }}</label>
              <md-input v-model="firstname"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Last Name") }}</label>
              <md-input v-model="lastname"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Email Address") }}</label>
              <md-input v-model="email" type="email"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Subject") }}</label>
              <md-input v-model="subjects"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Your Message") }}</label>
              <md-textarea v-model="message"></md-textarea>
            </md-field>
          </md-card-content>
          <md-card-actions class="d-flex justify-content-between">
            <md-checkbox v-model="boolean">{{
              $t("I'm not a robot")
            }}</md-checkbox>
            <md-button
              class="md-primary"
              :disabled="
                !boolean ||
                  firstName === '' ||
                  lastName === '' ||
                  message === '' ||
                  email === ''
              "
              @click="sendMessage"
              >{{ $t("Send Message") }}</md-button
            >
          </md-card-actions>
        </md-card>
        <br /><br />
      </div>
      <div class="md-layout-item md-size-10 md-small-size-100"></div>
      <div class="md-layout-item md-size-100 md-small-hide"></div>
      <div class="md-layout-item md-size-30 md-small-size-100"></div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  data() {
    return {
      firstname: "",
      lastname: "",
      message: "",
      email: "",
      subjects: "",
      boolean: false
    };
  },
  methods: {
    sendMessage() {
      this.$store.dispatch("auth/sendMessage", {
        firstname: this.firstname,
        lastname: this.lastname,
        message: this.message,
        subjects: this.subjects,
        email: this.email
      });
      swal.fire({
        title: this.$t("Acknowledgement"),
        text: this.$t(
          "Thank you for contacting us. We will get back to you shortly."
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });

      this.firstname = "";
      this.lastname = "";
      this.message = "";
      this.subjects = "";
      this.email = "";
    }
  }
};
</script>

<style lang="scss">
.justify-content-between {
  justify-content: space-between !important;
}
</style>
